import { Dropdown } from 'components';
import { languages, theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const LanguageSelector = ({}) => {
  const { t, i18n } = useTranslation(),
    { language } = useSelector((state) => state.appState),
    dispatch = useDispatch();

  function handleLanuageSelect(lang) {
    i18n.changeLanguage(lang.code);

    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        language: lang.code,
        languageManuallySet: true
      }
    });
  }

  return (
    <Dropdown
      title="$noTitle"
      noBorder
      pad="0px"
      wid="fit-content"
      upwards
      options={languages}
      optColor={theme.GREY_60}
      selected={languages.find((x) => x.code === language)}
      handleSelect={handleLanuageSelect}
      wrapperStyle={{ justifyContent: 'flex-start' }}
    />
  );
};

export default LanguageSelector;
